import api from '../../api'
import {
  COST_CENTERS_LOAD_DATA,
  COST_CENTERS_LOAD_DATA_SUCCESS,
  COST_CENTERS_LOAD_DATA_FAILED,
  COST_CENTERS_CREATION_DATA_SUCCESS,
  COST_CENTERS_UPDATE_DATA_SUCCESS,
  COST_CENTERS_DELETE_DATA_SUCCESS
} from '../mutations/available'
import {RequestState} from "../../requestState";
import state from '../state';

export const getAllCostCenters = async ({commit}) => {
  commit(COST_CENTERS_LOAD_DATA);

  let allCostCenters = null;
  try {
    allCostCenters = await api.getAllCostCenters();
    commit(COST_CENTERS_LOAD_DATA_SUCCESS, allCostCenters)
  } catch (e) {
    commit(COST_CENTERS_LOAD_DATA_FAILED, e);
    console.error(`Unable to get initial data, details: ${e.message}`)
  }

  return allCostCenters
};

export async function fetchAllCostCenters({commit, dispatch, state}) {
  if (state.fetchAllCostCenters === RequestState.Success ||
      state.fetchAllCostCenters === RequestState.Loading) {
    return
  }

  return dispatch('getAllCostCenters')
}

export async function createCostCenter({commit}, {title, type}) {
  if (!title) {
    console.error('Title field needed in createCostCenter action');
    return
  }

  if (!type) {
    console.error('Type field needed in createCostCenter action');
    return
  }

  let newCostCenter = null
  try {
    newCostCenter = await api.createCostCenter(title, type)
    commit(COST_CENTERS_CREATION_DATA_SUCCESS, newCostCenter)
  } catch (e) {
    console.error(`Unable to create cost center, details: ${e.message}`)
  }
}

export async function updateCostCenter({commit, dispatch, state}, {oldPosition, item}) {
  const {id, title, type} = item

  if (!(item && id && title && type)) {
    console.error(`Error in updateCostCenter action: id or title or type param isn't declared`)
    return
  }

  if ( oldPosition == -1 ) {
    console.warn(`Warn in updateCostCenter action: object ${item} doesn't exist`)
    return
  }

  try {
    const updatedCostCenter = await api.updateCostCenterTitle(id, title, type)
    commit(COST_CENTERS_UPDATE_DATA_SUCCESS, {oldPosition, updatedCostCenter})
  } catch (e) {
    console.error(`Unable to update cost center, details: ${e.message}`)
  }
}

export async function deleteCostCenter({commit}, item) {
  const {id, title} = item

  if (!item && !id && title) {
    console.error(`Error in deleteCostCenter action: id or title param isn't declared`)
    return
  }

  const itemPosition = state.costCenters.indexOf(item)

  if ( itemPosition == -1 ) {
    console.warn(`Warn in deleteCostCenter action: object ${item} doesn't exist`)
    return
  }

  try {
    await api.deleteCostCenterByID(id)
    commit(COST_CENTERS_DELETE_DATA_SUCCESS, itemPosition)
  } catch (e) {
    console.log(`Unable to delete cost center, details: ${e.message}`)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/cost-centers.js